import { Category, ListBullets } from '@/components/icons';
import {
    FilterChipBar,
    ListSection,
    SearchField,
    ViewModeToggle,
    type ViewModeToggleOption,
} from '@/components/system';
import { STATUS_FILTERS } from '../constants';
import type { DashboardFilterProps, ViewMode } from '../types';

const VIEW_MODE_OPTIONS: ViewModeToggleOption<ViewMode>[] = [
    {
        value: 'list',
        label: 'Visualizar laudos em lista',
        icon: ListBullets,
    },
    {
        value: 'grid',
        label: 'Visualizar laudos em grade',
        icon: Category,
    },
];

export const DashboardFilters = ({
    searchQuery,
    onSearchChange,
    viewMode,
    onViewModeChange,
    statusFilter,
    onStatusFilterChange,
    statusCounts,
    children,
    footer,
}: DashboardFilterProps) => {
    return (
        <ListSection
            title="Meus Laudos"
            contentClassName="p-0"
            headerClassName="p-4 sm:p-6"
            footerClassName="px-4 py-4 sm:px-6"
            footer={footer}
            search={
                <SearchField
                    id="tour-search-bar"
                    className="flex-1 md:min-w-[320px]"
                    placeholder="Buscar por paciente, modelo ou instrumento..."
                    value={searchQuery}
                    onValueChange={onSearchChange}
                />
            }
            controls={
                <ViewModeToggle
                    id="tour-view-mode"
                    value={viewMode}
                    onValueChange={onViewModeChange}
                    ariaLabel="Alternar visualização dos laudos"
                    className="hidden pb-0 md:flex"
                    options={VIEW_MODE_OPTIONS}
                />
            }
            filters={
                <FilterChipBar
                    ariaLabel="Filtrar laudos por status"
                    value={statusFilter}
                    onChange={onStatusFilterChange}
                    className="w-full flex-nowrap gap-2 overflow-x-auto pb-1 sm:flex-wrap sm:overflow-visible sm:pb-0"
                    options={STATUS_FILTERS.map((status) => ({
                        ...status,
                        count: statusCounts[status.value],
                        id: status.value === 'all' ? 'tour-status-filters' : undefined,
                    }))}
                />
            }
        >
            {children}
        </ListSection>
    );
};
